<template>
  <el-dialog
    title="产品明细"
    :visible.sync="visible"
    width="850px"
    @close="$emit('update:show', false)"
  >
    <ul class="details">
      <li v-if="outBill">
        <span class="title">物流单号：</span>
        <span>{{ model.express_number }}</span>
      </li>
      <li v-if="outBill">
        <span class="title">物流公司：</span>
        <span>{{ model.express_company }}</span>
      </li>
      <li>
        <span class="title">备&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp注：</span>
        <span>{{ model.remark }}</span>
      </li>
    </ul>
    <el-table :data="model.items">
      <el-table-column label="对象" width="60px">
        <template slot-scope="scope">{{scope.row.item.category == 1 ? "零件" : "设备"}}</template>
      </el-table-column>
      <el-table-column prop="item.name" label="名称" min-width="250px"></el-table-column>
      <el-table-column prop="item.part_number" label="件号" min-width="120px"></el-table-column>
      <el-table-column prop="item.machine_type" label="机型" min-width="120px"></el-table-column>
      <el-table-column label="单价" width="80">
        <template slot-scope="scope">{{scope.row.unit_price.toFixed(2)}}</template>
      </el-table-column>
      <el-table-column prop="item_number" label="数量" width="80"></el-table-column>
      <el-table-column prop="stockroom.name" label="仓库" width="100" v-if="outBill"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: {
    model: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    outBill: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show() {
      this.visible = this.show
    }
  },
  data() {
    return {
      visible: this.show
    }
  },
  methods: {}
}
</script>
<style scoped>
.details {
  padding-left: 10px;
}
.details li {
  padding: 8px 0;
  display: flex;
}

.details li .title {
  width: 80px;
}
</style>